var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99978 0C2.24287 0 0 2.17969 0 4.85862C0 7.43733 4.53639 13.4621 4.72954 13.7172L4.90981 13.9556C4.93089 13.9836 4.96446 14 4.99978 14C5.03565 14 5.069 13.9836 5.0903 13.9556L5.27046 13.7172C5.46372 13.4621 10 7.43733 10 4.85862C10 2.17969 7.75676 0 4.99978 0ZM4.99978 3.11827C5.98759 3.11827 6.79084 3.89881 6.79084 4.85862C6.79084 5.81794 5.98755 6.59897 4.99978 6.59897C4.01255 6.59897 3.20873 5.81794 3.20873 4.85862C3.20873 3.89881 4.01252 3.11827 4.99978 3.11827Z",
    fill: "#FFAE24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b18bbc825e917a221108e4b7c770069b.svg";
export { ForwardRef as ReactComponent };